import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin } from "lucide-react";
import { EVARA } from "@/data/evara";

export default function Footer() {
  return (
    <footer className="bg-soft-sage border-t border-[var(--evara-border)] mt-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <img src={EVARA.logoUrl} alt="EVARA" className="h-12 w-12 object-contain" />
              <div>
                <div className="font-serif text-2xl tracking-wide" style={{ color: "var(--evara-primary)" }}>
                  EVARA
                </div>
                <div className="text-[10px] tracking-[0.16em] uppercase text-[var(--evara-text-2)]">
                  Ever Growing Excellence
                </div>
              </div>
            </div>
            <p className="font-serif text-lg text-[var(--evara-primary)] max-w-md">
              {EVARA.tagline}.
            </p>
            <p className="mt-4 text-sm text-[var(--evara-text-2)] max-w-md leading-relaxed">
              {EVARA.mission}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow mb-4">Explore</div>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="hairline-link" data-testid="footer-about-link">About EVARA</Link></li>
              <li><Link to="/services" className="hairline-link" data-testid="footer-services-link">Services</Link></li>
              <li><Link to="/framework" className="hairline-link" data-testid="footer-framework-link">Framework</Link></li>
              <li><Link to="/industries" className="hairline-link" data-testid="footer-industries-link">Industries</Link></li>
              <li><Link to="/book" className="hairline-link" data-testid="footer-book-link">Schedule a Consultation</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="eyebrow mb-4">Get in touch</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-0.5 text-[var(--evara-primary)]" />
                <a href={`mailto:${EVARA.contact.email}`} className="hairline-link" data-testid="footer-email">
                  {EVARA.contact.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={16} className="mt-0.5 text-[var(--evara-primary)]" />
                <a href={`tel:${EVARA.contact.phone.replace(/\s+/g, "")}`} className="hairline-link" data-testid="footer-phone">
                  {EVARA.contact.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-[var(--evara-primary)]" />
                <span data-testid="footer-address">{EVARA.contact.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Linkedin size={16} className="mt-0.5 text-[var(--evara-primary)]" />
                <a href={EVARA.contact.linkedin} target="_blank" rel="noreferrer" className="hairline-link" data-testid="footer-linkedin">
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="divider-rule mt-12 mb-6" />
        <div className="flex flex-col md:flex-row justify-between gap-3 text-xs text-[var(--evara-text-2)]">
          <div>© {new Date().getFullYear()} EVARA · Ever Growing Excellence. All rights reserved.</div>
          <div className="flex gap-6">
            <span>Privacy</span>
            <span>Terms</span>
            <Link to="/admin" className="hairline-link" data-testid="footer-admin-link">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
